import type { ProductHitPrice } from '@libs/algolia';
import type { ProductPriceVariant } from '@app/pdp/components/ProductPrice';

export const productPriceVariantMapper = (
    productPrice: ProductHitPrice
): ProductPriceVariant => {
    const mappedProductPriceVariant: ProductPriceVariant = 'primary';

    if (productPrice['strikethrough-number']) {
        return 'disabled';
    }

    return mappedProductPriceVariant;
};
